const UserActionTypes = {
  ADD_USER: "ADD_USER",
  EDIT_USER: "EDIT_USER",
  GET_USER: "GET_USER",
  CHANGE_STATUS_USER: "CHANGE_STATUS_USER",
  UPDATE_PROFILE_PHOTO: "UPDATE_PROFILE_PHOTO",
};

export default UserActionTypes;
